"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSubscriptionsControllerGetMySubscriptionV1200Response = instanceOfSubscriptionsControllerGetMySubscriptionV1200Response;
exports.SubscriptionsControllerGetMySubscriptionV1200ResponseFromJSON = SubscriptionsControllerGetMySubscriptionV1200ResponseFromJSON;
exports.SubscriptionsControllerGetMySubscriptionV1200ResponseFromJSONTyped = SubscriptionsControllerGetMySubscriptionV1200ResponseFromJSONTyped;
exports.SubscriptionsControllerGetMySubscriptionV1200ResponseToJSON = SubscriptionsControllerGetMySubscriptionV1200ResponseToJSON;
exports.SubscriptionsControllerGetMySubscriptionV1200ResponseToJSONTyped = SubscriptionsControllerGetMySubscriptionV1200ResponseToJSONTyped;
var MySubscriptionResponseDto_1 = require("./MySubscriptionResponseDto");
/**
 * Check if a given object implements the SubscriptionsControllerGetMySubscriptionV1200Response interface.
 */
function instanceOfSubscriptionsControllerGetMySubscriptionV1200Response(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function SubscriptionsControllerGetMySubscriptionV1200ResponseFromJSON(json) {
    return SubscriptionsControllerGetMySubscriptionV1200ResponseFromJSONTyped(json, false);
}
function SubscriptionsControllerGetMySubscriptionV1200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, MySubscriptionResponseDto_1.MySubscriptionResponseDtoFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function SubscriptionsControllerGetMySubscriptionV1200ResponseToJSON(json) {
    return SubscriptionsControllerGetMySubscriptionV1200ResponseToJSONTyped(json, false);
}
function SubscriptionsControllerGetMySubscriptionV1200ResponseToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, MySubscriptionResponseDto_1.MySubscriptionResponseDtoToJSON)(value['data']),
        'error': value['error'],
        'errorCode': value['errorCode'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
